export const browserLang: string = navigator.language;
export const OPTIONS_DATE = { year: 'numeric', month: '2-digit', day: '2-digit' }
// tslint:disable-next-line
export type formatDate = 'date' | 'hours' | 'month-years';

export function date(date: any = new Date(), options: any = { year: 'numeric', month: '2-digit', day: '2-digit' }) {
  return new Intl.DateTimeFormat('pt-BR', options).format(date);
}

export const formatDate = (data: string, tipeFormat: formatDate = 'date') => {
  console.warn('deprecated');
  const DATE_REGEX = new RegExp(/^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/);
  let date = ''
  let hours = ''
  let monthYears = ''
  /////////////////////
  /// Fortmat invalid
  /////////////////////
  if (!DATE_REGEX.test(data)) {
    return date
  }
  ////////////////////////////
  ///// Fortmat Date Valid
  ////////////////////////////
  const newDate = data.split('T')
  if (newDate.length == 2) {
    // Create date Formated
    const dt = newDate[0].split('-')
    date = `${dt[2]}/${dt[1]}/${dt[0]}`
    // create hours
    const ht = newDate[1].split(':')
    hours = `${ht[0]}:${ht[1]}`
    // create mont-years
    monthYears = `${dt[1]}/${dt[0]}`
  }
  ///// Get Hours
  if (tipeFormat === 'hours') {
    return hours
  }
  if (tipeFormat === 'month-years') {
    return monthYears
  }
  return date
}


export function addBusinessDays(date: Date, offset: number) {
  date = new Date(date.getTime());

  let day = date.getDay();

  date.setDate(date.getDate() + offset + (day === 6 ? 2 : +!day) + (Math.floor((offset - 1 + (day % 6 || 1)) / 5) * 2));
  return date;
}

// tslint:disable-next-line
export function utc(date: Date = new Date()) {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds()
  );
}

export function dateDiff(date1: Date, date2: Date): { days: number, months: number, years: number } {
  const differenceInMilisecond = date1.valueOf() - date2.valueOf(),
    years = Math.floor(differenceInMilisecond / 31536000000),
    days = Math.floor((differenceInMilisecond % 31536000000) / 86400000),
    months = Math.floor(days / 30);

  return { days, months, years };
}

export function number(value: number) {
  return new Intl.NumberFormat('pt-BR').format(value);
}

export function removeTimeZone(list: Array<any>, date = 'data') {
  const newlist = list.map(item => {
    item[date] = item[date]
      .replace(/T/g, ' ')
      .replace(/Z/g, '')
      .replace(/-/g, '/')
    return item
  });
  return newlist
}

export function currency(value: number = 0, options: any = { style: 'currency', currency: 'BRL' }) {
  return new Intl.NumberFormat('pt-BR', options).format(value);
}

export function cleanFloat(value: string | number): number {
  if (!value) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }

  const digits = (<string>value).replace(/[^\d-]/g, '').split('');

  if ((<string>value).match(/([,.]\d{1}$)/g)) {
    digits.splice(digits.length - 1, 0, '.');
  } else if ((<string>value).match(/([,.]\d{2}$)/g)) {
    digits.splice(digits.length - 2, 0, '.');
  }

  return parseFloat(digits.join('') || '0');
}

export function percent(total: number, partial: number, percentage: number = 100, formated: boolean = true) {
  const value = Math.round((percentage * partial / total) * 100) / 100;

  return formated ? value.toFixed(2) + '%' : value;
}

export function urlEncode(params) {
  return Object.keys(params).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
  }).join('&');
}

export function cpf(value: string) {
  if (!value) {
    return value;
  }

  value = value.toString().replace(/\D/g, '');

  return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function cnpj(value: string) {
  if (!value) {
    return value;
  }

  value = value.toString().replace(/\D/g, '');

  return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function capitalize(value: string) {
  const splittedValue = value.split(' ').map((segment) => {
    return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
  });

  return splittedValue.join(' ');
}

export function removeAcentos(value: string) {
  const mapHexAcentos = {
    a: /[\xE0-\xE6]/g,
    A: /[\xC0-\xC6]/g,
    e: /[\xE8-\xEB]/g,
    E: /[\xC8-\xCB]/g,
    i: /[\xEC-\xEF]/g,
    I: /[\xCC-\xCF]/g,
    o: /[\xF2-\xF6]/g,
    O: /[\xD2-\xD6]/g,
    u: /[\xF9-\xFC]/g,
    U: /[\xD9-\xDC]/g,
    c: /\xE7/g,
    C: /\xC7/g,
    n: /\xF1/g,
    N: /\xD1/g,
  };

  // tslint:disable-next-line
  for (const char in mapHexAcentos) {
    const regExp = mapHexAcentos[char];

    value = value.replace(regExp, char);
  }

  return value;
}



export function regexAcentosPossiveis(value: string, regexFlags: string = 'gi') {
  const mapHexAcentos = {
    a: '[\xE0-\xE6|a]',
    A: '[\xC0-\xC6|A]',
    e: '[\xE8-\xEB|e]',
    E: '[\xC8-\xCB|E]',
    i: '[\xEC-\xEF|i]',
    I: '[\xCC-\xCF|I]',
    o: '[\xF2-\xF6|o]',
    O: '[\xD2-\xD6|O]',
    u: '[\xF9-\xFC|u]',
    U: '[\xD9-\xDC|U]',
    c: '[\xE7|c]',
    C: '[\xC7|C]',
    n: '[\xF1|n]',
    N: '[\xD1|N]',
  };

  return new RegExp(value.replace(/[aeioucn]/gi, (char) => mapHexAcentos[char] || char), regexFlags);
}

export function acentoHtmlEntity(value: string) {
  return value.replace(/\xC0/g, '&Agrave;')
    .replace(/\xC1/g, '&Aacute;')
    .replace(/\xC2/g, '&Acirc;')
    .replace(/\xC3/g, '&Atilde;')
    .replace(/\xC4/g, '&Auml;')
    .replace(/\xC5/g, '&Aring;')
    .replace(/\xC6/g, '&AElig;')
    .replace(/\xC7/g, '&Ccedil;')
    .replace(/\xC8/g, '&Egrave;')
    .replace(/\xC9/g, '&Eacute;')
    .replace(/\xCA/g, '&Ecirc;')
    .replace(/\xCB/g, '&Euml;')
    .replace(/\xCC/g, '&Igrave;')
    .replace(/\xCD/g, '&Iacute;')
    .replace(/\xCE/g, '&Icirc;')
    .replace(/\xCF/g, '&Iuml;')
    .replace(/\xD0/g, '&ETH;')
    .replace(/\xD1/g, '&Ntilde;')
    .replace(/\xD2/g, '&Ograve;')
    .replace(/\xD3/g, '&Oacute;')
    .replace(/\xD4/g, '&Ocirc;')
    .replace(/\xD5/g, '&Otilde;')
    .replace(/\xD6/g, '&Ouml;')
    .replace(/\xD8/g, '&Oslash;')
    .replace(/\xD9/g, '&Ugrave;')
    .replace(/\xDA/g, '&Uacute;')
    .replace(/\xDB/g, '&Ucirc;')
    .replace(/\xDC/g, '&Uuml;')
    .replace(/\xDD/g, '&Yacute;')
    .replace(/\xDE/g, '&THORN;')
    .replace(/\xDF/g, '&szlig;')
    .replace(/\xE0/g, '&agrave;')
    .replace(/\xE1/g, '&aacute;')
    .replace(/\xE2/g, '&acirc;')
    .replace(/\xE3/g, '&atilde;')
    .replace(/\xE4/g, '&auml;')
    .replace(/\xE5/g, '&aring;')
    .replace(/\xE6/g, '&aelig;')
    .replace(/\xE7/g, '&ccedil;')
    .replace(/\xE8/g, '&egrave;')
    .replace(/\xE9/g, '&eacute;')
    .replace(/\xEA/g, '&ecirc;')
    .replace(/\xEB/g, '&euml;')
    .replace(/\xEC/g, '&igrave;')
    .replace(/\xED/g, '&iacute;')
    .replace(/\xEE/g, '&icirc;')
    .replace(/\xEF/g, '&iuml;')
    .replace(/\xF0/g, '&eth;')
    .replace(/\xF1/g, '&ntilde;')
    .replace(/\xF2/g, '&ograve;')
    .replace(/\xF3/g, '&oacute;')
    .replace(/\xF4/g, '&ocirc;')
    .replace(/\xF5/g, '&otilde;')
    .replace(/\xF6/g, '&ouml;')
    .replace(/\xF8/g, '&oslash;')
    .replace(/\xF9/g, '&ugrave;')
    .replace(/\xFA/g, '&uacute;')
    .replace(/\xFB/g, '&ucirc;')
    .replace(/\xFC/g, '&uuml;')
    .replace(/\xFD/g, '&yacute;')
    .replace(/\xFE/g, '&thorn;')
    .replace(/\xFF/g, '&yuml;')
    .replace(/\u0152/g, '&OElig;')
    .replace(/\u0153/g, '&oelig;')
    .replace(/\u0160/g, '&Scaron;')
    .replace(/\u0161/g, '&scaron;')
    .replace(/\u0178/g, '&Yuml;')
    .replace(/\u0192/g, '&fnof;');
}

export function snakeCaseToCamelCase(value: string) {
  return value.replace(/(\_\w)/g, function (m) {
    return m[1].toUpperCase();
  });
}

export function valueToArray(value: any): any[] {
  return Array.isArray(value) ? value : [value];
}

export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/*
    - Abaixo de 0 a 1, duas casa decimais
    - Entre 1 e 100, apenas uma casa decimal
    - Entre 100 e 1000 sem casas decimais
    - De 1000 a 10.000 ignora a unidade (1009 => 1010). 10 em 10
    - Acima de 10.000 a 100.000 a partir de 1000
    - Acima de 100.000
     */
export function arrendondaVazao(value: number | string) {
  if (!value) { return value; }

  if (typeof value == 'string') {
    value = parseFloat(value);
  }

  if (value < 1) {
    return value.toFixed(2);
  }
  if (value < 100) {
    return value.toFixed(1);
  }
  if (value < 1000) {
    return value.toFixed(0);
  }
  if (value < 10000) {
    return Math.round(value * .1) * 10
  }
  if (value < 100000) {
    return Math.round(value * .01) * 100
  }

  return Math.round(value * .001) * 1000;
}
